import { render, staticRenderFns } from "./PoliciesList.vue?vue&type=template&id=1ff9d15e&scoped=true&"
import script from "./PoliciesList.vue?vue&type=script&lang=js&"
export * from "./PoliciesList.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesList.vue?vue&type=style&index=0&id=1ff9d15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9d15e",
  null
  
)

export default component.exports